/* unplugin-vue-components disabled */import { render } from "./SaleData.vue?vue&type=template&id=15790fc0&scoped=true&ts=true"
import script from "./SaleData.vue?vue&type=script&lang=ts"
export * from "./SaleData.vue?vue&type=script&lang=ts"

import "./SaleData.vue?vue&type=style&index=0&id=15790fc0&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15790fc0"]])

export default __exports__